/**
 * state
 */
const state = {
  visible: false,
  announcementBarVisible: true,
};

/**
 * getters
 */
const getters = {};

/**
 * mutations
 */
const mutations = {
  TOGGLE(state) {
    state.visible = !state.visible;
  },

  SHOW(state) {
    state.visible = true;
  },

  HIDE(state) {
    state.visible = false;
  },

  HIDE_ANNOUNCEMENT_BAR(state) {
    state.announcementBarVisible = false;
  },
};

/**
 * actions
 */
const actions = {
  toggle({commit}) {
    commit("TOGGLE");
  },

  show({commit}) {
    commit("SHOW");
  },

  hide({commit}) {
    commit("HIDE");
  },

  hideAnnouncementBar({commit}) {
    commit("HIDE_ANNOUNCEMENT_BAR");
  },
};

/**
 * export
 */
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
